import React, { useEffect } from 'react'
import notification from 'antd/es/notification'
import { setGlobalNotificationApi } from '@/utils/global-notification.ts'

// Static `notification.error()` can't read the ConfigProvider context, so it
// renders unthemed (and, inside a ConfigProvider with cssVar, not at all).
// Mount this inside the theme provider once per root layout so non-React code
// (api.util.ts) can notify through a context-aware instance.
export const GlobalNotificationHolder: React.FC = () => {
  const [api, contextHolder] = notification.useNotification()

  useEffect(() => {
    setGlobalNotificationApi(api)
  }, [api])

  return contextHolder
}
